import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames'; 
import PersonalProtectiveEquipmentReturn from '../Forms/PersonalProtectiveEquipmentReturn';

const AddEditPersonalProtectiveEquipmentReturnModal = ({
	dataListSelect,
	isOpen,
	isEdit,
	handleToggleReturnModal,
	activeTab,
	toggleTab,
	onCleanSelection
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleReturnModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleReturnModal}>
				Devolver Equipamiento de Protección Personal
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>
							Información General
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '2' })} onClick={() => { toggleTab('2'); }}>
							Items a Devolver
						</NavLink>
					</NavItem>
				</Nav>
			</div>

			<PersonalProtectiveEquipmentReturn
				dataListSelect={dataListSelect}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleReturnModal={handleToggleReturnModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				onCleanSelection={onCleanSelection}
			/>
		</Modal>
	);
};

export default AddEditPersonalProtectiveEquipmentReturnModal;
